"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleGate = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../common/constants");
var _semanticUiReact = require("semantic-ui-react");
var _error = _interopRequireDefault(require("../../go/components/common/error"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ToggleGate = /*#__PURE__*/_react.default.memo(function (_ref) {
  var toggleStatus = _ref.toggleStatus,
    children = _ref.children;
  // Render contents once toggles finish, loader until then, error if it times out
  switch (toggleStatus) {
    case _constants.TOGGLE_SUCCESS:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
    case _constants.TOGGLE_ERROR:
      return /*#__PURE__*/_react.default.createElement(_error.default, {
        message: ""
      });
    case _constants.TOGGLE_LOADING:
    default:
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
        active: true
      }, "Loading...");
  }
});
exports.ToggleGate = ToggleGate;